import { formatUserFacingError } from '@/lib/errors'
import { useEffect, useState } from 'react'
import { seasonsService } from '../services/seasons.service'
import type { FilmDocument } from '@/types'

interface UseFilmsResult {
  films: Array<FilmDocument & { id: string }>
  loading: boolean
  error: string | null
}

export function useFilms(seasonNumber: number | null): UseFilmsResult {
  const [films, setFilms] = useState<Array<FilmDocument & { id: string }>>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (seasonNumber === null) return
    setLoading(true)
    setError(null)
    seasonsService
      .getFilmsBySeason(seasonNumber)
      .then(setFilms)
      .catch((err: unknown) => setError(formatUserFacingError(err, 'Failed to load films')))
      .finally(() => setLoading(false))
  }, [seasonNumber])

  return { films, loading, error }
}
